import React, { CSSProperties, FC } from 'react'
import * as TooltipRadix from '@radix-ui/react-tooltip'

interface TooltipProps {
    content: string
    children: React.ReactNode
    position?: 'top' | 'bottom' | 'left' | 'right'
}

const tooltipContentStyle: CSSProperties = {
    backgroundColor: 'black',
    color: 'white',
    padding: '6px 10px',
    borderRadius: '4px',
    fontSize: '14px',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
    maxWidth: '200px',
}

export const Tooltip: FC<TooltipProps> = ({
    content,
    children,
    position = 'top',
}) => {
    return (
        <TooltipRadix.Provider delayDuration={300}>
            <TooltipRadix.Root>
                <TooltipRadix.Trigger asChild>{children}</TooltipRadix.Trigger>
                <TooltipRadix.Content
                    side={position}
                    style={tooltipContentStyle}
                >
                    {content}
                    <TooltipRadix.Arrow style={{ fill: 'black' }} />
                </TooltipRadix.Content>
            </TooltipRadix.Root>
        </TooltipRadix.Provider>
    )
}
